import { render, staticRenderFns } from "./PaymentAppChannelSetting.vue?vue&type=template&id=fc4f5558&"
import script from "./PaymentAppChannelSetting.vue?vue&type=script&lang=js&"
export * from "./PaymentAppChannelSetting.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAppChannelSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports